import React, { useState } from 'react';

import { cutText } from 'utils';

import { ReactComponent as ArrownDownIcon } from 'pages/Teachers/Assignments/CreateMathV2/assets/arrow-down-icon.svg';
import { ReactComponent as CalendarIcon } from 'pages/Teachers/Assignments/CreateMathV2/assets/calendar-icon.svg';
import { ReactComponent as CloseIcon } from 'pages/Teachers/Assignments/CreateMathV2/assets/close-icon.svg';
import { ReactComponent as PersonIcon } from 'pages/Teachers/Assignments/CreateMathV2/assets/person-icon.svg';

import DateTimeField from 'components/DateTimeField';

import styles from './styles.module.scss';

const ClassSelector = ({ sections, selectedSections, setSelectedSections }) => {
  const [openDatePickerSection, setOpenDatePickerSection] = useState(null);
  const [dueDatePickerSection, setDueDatePickerSection] = useState(null);

  const addSection = ({ section }) => {
    if (!selectedSections.find((s) => s.id === section.id)) {
      const firstSection = selectedSections[0];

      let defaultOpen, defaultDue;

      if (firstSection) {
        defaultOpen = firstSection.open;
        defaultDue = firstSection.due;
      } else {
        const now = new Date();
        const inTwoDays = new Date();
        inTwoDays.setDate(now.getDate() + 2);

        defaultOpen = now.toISOString();
        defaultDue = inTwoDays.toISOString();
      }

      setSelectedSections([
        ...selectedSections,
        {
          ...section,
          open: defaultOpen,
          due: defaultDue
        }
      ]);
    }
  };

  const removeSection = ({ id }) => {
    setSelectedSections(selectedSections.filter((s) => s.id !== id));
  };

  const handleClassSelect = (e) => {
    const sectionId = Number(e.target.value);
    const section = sections.find((s) => s.id === sectionId);

    if (section) {
      addSection({ section });
      e.target.value = '';
    }
  };

  const handleDateChange = (id, field, date) => {
    setSelectedSections(
      selectedSections.map((s) => (s.id === id ? { ...s, [field]: date } : s))
    );
  };

  return (
    <div className={styles.fieldSection}>
      <div className={styles.fieldLabel}>
        <PersonIcon /> <span>Assign To Class</span>
      </div>

      <div className={styles.selectWrapper}>
        <select
          defaultValue=""
          onChange={handleClassSelect}
          className={styles.inputField}
        >
          <option value="" disabled>
            Select a class...
          </option>
          {sections.map((section) => (
            <option key={section.id} value={section.id}>
              {cutText({
                text: section.name,
                char: 55
              })}
            </option>
          ))}
        </select>
        <ArrownDownIcon className={styles.chevron} />
      </div>

      <div className={styles.selectedSectionsList}>
        {selectedSections.map((section) => (
          <div key={section.id} className={styles.selectedSectionCard}>
            <div className={styles.sectionCardHeader}>
              <span className={styles.sectionName}>
                {cutText({ text: section.name, char: 55 })}{' '}
                {section.students_count
                  ? `- ${section.students_count} students`
                  : ''}
              </span>
              <button
                className={styles.removeSectionBtn}
                onClick={() => removeSection({ id: section.id })}
              >
                <CloseIcon />
              </button>
            </div>

            <div className={styles.dateControls}>
              <DateTimeField
                id={`open-${section.id}`}
                name={`open-${section.id}`}
                value={section.open}
                onChange={(date) => handleDateChange(section.id, 'open', date)}
                open={openDatePickerSection === section.id}
                onClose={() => setOpenDatePickerSection(null)}
                TextFieldComponent={({ value }) => (
                  <button
                    type="button"
                    onClick={() => setOpenDatePickerSection(section.id)}
                    className={styles.dateButton}
                  >
                    {value ? `Open: ${value}` : 'Add Open Time'}{' '}
                    <CalendarIcon />
                  </button>
                )}
              />

              <DateTimeField
                id={`due-${section.id}`}
                name={`due-${section.id}`}
                value={section.due}
                minDate={section.open}
                onChange={(date) => handleDateChange(section.id, 'due', date)}
                open={dueDatePickerSection === section.id}
                onClose={() => setDueDatePickerSection(null)}
                TextFieldComponent={({ value }) => (
                  <button
                    type="button"
                    onClick={() => setDueDatePickerSection(section.id)}
                    className={styles.dateButton}
                  >
                    {value ? `Due: ${value}` : 'Add Due Date'} <CalendarIcon />
                  </button>
                )}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClassSelector;
